import ILanguage from '@/admin/helpers/interfaces/language-types'
import { deleteLanguage, editLanguage, getAllLanguages, saveLanguage } from '@/services/language/languageService';
import { createModel } from '@rematch/core'

const initialState: { languages: ILanguage[], language: ILanguage | null, editMode: boolean, isloaded: boolean } = {
    isloaded: false,
    language: null,
    languages: [],
    editMode: false

}
export const languageModel = createModel()({
    state: { ...initialState },
    reducers: {

        setLanguages(state, payload) {
            return {
                ...state,
                languages: payload.data,
            }
        },
        setIsLoading(state, payload){

            return {
                ...state,
                isloaded: payload

            }
        }, 
        editLanguage(state, payload) {  
            return {
                ...state,
                language: payload.language,

            }
        },
        setMode(state, payload) {
            return {
                ...state,
                editMode: payload.editMode,
            }
        },
     

    },
    effects: (dispatch) => ({

        
        async getLanguageAsync() {
			 const response = await getAllLanguages();
			if (response) { 				 
			   this.setLanguages({ data: response.data })
				return response
			} else {
				this.setLanguages({ response: [] })
                return {}
			}

		},

        async saveLanguageAsync(payload, rootState) {

            return await saveLanguage(payload);

        },

        async editLanguageAsync(payload, rootState) {
            return await editLanguage(payload);
        },

        async deleteLanguagesAsync(payload, rootState) {
            return await deleteLanguage(payload);
        },



	}),

})